import { StepType } from '../../constants'

export const getName = (fieldName: string, type: StepType) =>
  `${type}.${fieldName}`

export const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}